import React from 'react';
import { useStudio } from '../../contexts/StudioContext';
import { duration, euro } from '../../utils/format';
export function ServicesAdmin() {
  const {
    services,
    extras,
    saveService,
    saveExtra
  } = useStudio();
  const numberField = 'w-full rounded-xl border border-edge bg-panel px-4 py-3 text-sm text-chalk focus:border-ember';
  return <div className="w-full max-w-full px-4 py-5 lg:px-8 lg:py-8" data-id="element-960" data-mp="2smjkcwmzbl2g">
      <header data-id="element-961" data-mp="1v0lwejptynj4">
        <h1 className="hidden font-display text-2xl font-extrabold tracking-tightest text-chalk lg:block lg:text-3xl" data-id="element-962" data-mp="1v143kbe16m5t">
          Diensten en prijzen
        </h1>
        <p className="text-sm text-dim lg:mt-1.5" data-id="element-963" data-mp="24x72779oc2o0">
          Prijzen en doorlooptijden bepalen direct wat klanten online zien en kunnen boeken.
        </p>
      </header>

      <div className="mt-7 space-y-4" data-id="element-964" data-mp="29qa2dy8yiad6">
        {services.map(service => <section key={service.id} className="rounded-2xl border border-edge bg-carbon p-5 lg:p-6" data-id="element-965" data-mp="1c8t6wz9yzkg5">
            <div className="flex flex-wrap items-start justify-between gap-4" data-id="element-966" data-mp="1h6bdij0ilnkz">
              <div className="flex min-w-0 items-center gap-4" data-id="element-967" data-mp="10qdc2b62mhmz">
                <img src={service.image} alt="" aria-hidden="true" className="h-14 w-16 shrink-0 rounded-xl object-cover lg:h-16 lg:w-20" data-id="element-968" data-mp="vra7ssxx0fg2" />
                <div className="min-w-0" data-id="element-969" data-mp="m18u8v36uffe">
                  <h2 className="font-display text-lg font-extrabold tracking-tight text-chalk" data-id="element-970" data-mp="m05zud6npuuq">
                    {service.name}
                  </h2>
                  <p className="mt-1 text-sm text-dim" data-id="element-971" data-mp="d0j1k098555w">
                    {euro(service.price)} · {duration(service.durationMinutes)}
                  </p>
                </div>
              </div>

              <label className="flex items-center gap-3 text-sm text-dim" data-id="element-972" data-mp="34fxupyq4ygu">
                <input type="checkbox" checked={service.active} onChange={e => saveService({
              ...service,
              active: e.target.checked
            })} className="h-4 w-4 accent-[#ff6a2b]" data-id="element-973" data-mp="22gieztjvlgrc" />
                Online boekbaar
              </label>
            </div>

            <div className="mt-5 grid grid-cols-1 gap-4 sm:grid-cols-2" data-id="element-974" data-mp="kawvl5bith2">
              <div data-id="element-975" data-mp="3i09bfjiydqzm">
                <label htmlFor={`price-${service.id}`} className="text-sm font-medium text-chalk" data-id="element-976" data-mp="3i0svb5s5ypga">
                  Vanafprijs (€)
                </label>
                <input id={`price-${service.id}`} type="number" min={0} step={5} value={service.price} onChange={e => saveService({
              ...service,
              price: Number(e.target.value)
            })} className={`mt-2 ${numberField}`} data-id="element-977" data-mp="ehzjoyiy4aor" />
              </div>
              <div data-id="element-978" data-mp="9l91o5nkz50p">
                <label htmlFor={`duration-${service.id}`} className="text-sm font-medium text-chalk" data-id="element-979" data-mp="2q7inrxfc5alz">
                  Doorlooptijd (minuten)
                </label>
                <input id={`duration-${service.id}`} type="number" min={30} step={30} value={service.durationMinutes} onChange={e => saveService({
              ...service,
              durationMinutes: Number(e.target.value)
            })} className={`mt-2 ${numberField}`} data-id="element-980" data-mp="2u7j3dle67rum" />
              </div>
            </div>
          </section>)}
      </div>

      <h2 className="mt-10 font-display text-xl font-extrabold tracking-tight text-chalk" data-id="element-981" data-mp="240ek4jd6azhq">Extra's</h2>
      <div className="mt-4 grid grid-cols-1 gap-4 lg:grid-cols-3" data-id="element-982" data-mp="1z1uvgb7739lo">
        {extras.map(extra => <section key={extra.id} className="rounded-2xl border border-edge bg-carbon p-5" data-id="element-983" data-mp="2dq7uxi5hrakx">
            <div className="flex items-start justify-between gap-3" data-id="element-984" data-mp="28xxwteu8347k">
              <h3 className="font-display text-base font-extrabold tracking-tight text-chalk" data-id="element-985" data-mp="1l8lpylmdb88f">{extra.name}</h3>
              <label className="flex items-center gap-2 text-xs text-dim" data-id="element-986" data-mp="1gatyfspmxo4r">
                <input type="checkbox" checked={extra.active} onChange={e => saveExtra({
              ...extra,
              active: e.target.checked
            })} className="h-4 w-4 accent-[#ff6a2b]" data-id="element-987" data-mp="jix974301n6m" />
                Actief
              </label>
            </div>
            <p className="mt-1.5 text-xs text-dim" data-id="element-988" data-mp="xabszd4qdseq">{extra.note}</p>

            <div className="mt-4 grid grid-cols-1 gap-3 sm:grid-cols-2" data-id="element-989" data-mp="xbwl6w3koz9f">
              <div data-id="element-990" data-mp="128vi1memfkbb">
                <label htmlFor={`ep-${extra.id}`} className="text-xs text-dim" data-id="element-991" data-mp="12bhkx8qkhbn7">
                  Prijs (€)
                </label>
                <input id={`ep-${extra.id}`} type="number" min={0} step={5} value={extra.price} onChange={e => saveExtra({
              ...extra,
              price: Number(e.target.value)
            })} className={`mt-1.5 ${numberField}`} data-id="element-992" data-mp="1b9bewd0uzt77" />
              </div>
              <div data-id="element-993" data-mp="3i243oqt9q1k2">
                <label htmlFor={`ed-${extra.id}`} className="text-xs text-dim" data-id="element-994" data-mp="3aha23elx6w0b">
                  Minuten
                </label>
                <input id={`ed-${extra.id}`} type="number" min={0} step={15} value={extra.durationMinutes} onChange={e => saveExtra({
              ...extra,
              durationMinutes: Number(e.target.value)
            })} className={`mt-1.5 ${numberField}`} data-id="element-995" data-mp="35p9v527fn2u8" />
              </div>
            </div>
          </section>)}
      </div>
    </div>;
}